export interface AuthenticatedLoginResponse {
  sessionid: string
  tokenQSP: string
}

export interface MfaChallengeResponse {
  mfaRequired: true
  challengeId: string
  maskedEmail: string
  expiresInSeconds: number
  resendAvailableInSeconds: number
}

export type LoginResponse = AuthenticatedLoginResponse | MfaChallengeResponse

export interface MfaVerifyRequest {
  challengeId: string
  code: string
}

export interface MfaResendRequest {
  challengeId: string
}

export function isMfaChallenge(response: unknown): response is MfaChallengeResponse {
  return !!response && typeof response === 'object' && (response as MfaChallengeResponse).mfaRequired === true
}
